/*
 * @Description:
 * @Author: zwcong
 * @Date: 2024-11-27 14:48:55
 * @LastEditors: zwcong
 * @LastEditTime: 2025-08-04 16:07:51
 */
/**
 * 公共配置
 */
/* eslint-disable global-require */
export default {
  logo: {
    // 彩色常规LOGO
    normal: require('assets/images/common/logo.png'),
    // 白色常规LOGO
    normalWhite: require('assets/images/common/logo-white.png'),
    // 彩色LOGO图标
    simple: require('assets/images/common/icon-logo.svg'),
    // 白色LOGO图标
    simpleWhite: require('assets/images/common/icon-logo-white.svg'),
    // 加载中图标
    loading: require('assets/images/common/logo-loading.png'),
  },
  // 日期格式化方式
  dateFormatLine: 'DD-MM-YYYY',
  // 重试
  retry: 'Retry',
  // 尾部是否显示邮箱
  showContactEmail: true,
  // 联系电话显示字符
  contactPhoneString: '',
  stage3Null: 'Appointments are temporarily unavailable. We recommend that you start an online evaluation directly.',
  // 请输入邮箱
  emailPlaceholder: '请输入邮箱',
  // 请输入正确的邮箱
  emailError: '请输入正确的邮箱',
}
